<template>
    <tablecustom 
        @search="searchB" 
        :columns="columns" 
        :rows="filteredItems" 
        @open="open"
        :datafilter="filterAll"
        :objParams="objParams"
        @change="change" 
        @clearFilter="clearFilter"
    />

    <modal v-if="showModal" @close="showModal = false" :title="item.deviceTitle ">
        <template v-slot:head-bottom>
            <button type="button" class="btn btn-soft-danger btn-icon btn-sm fs-16 close-btn-email"  @click="$emit('close')"><i class="ri-close-fill align-bottom"></i></button>
        </template>
        <template v-slot:status>
            <span :class="`${mutateStatusDevices(item.active).color} align-middle fs-14`">{{ mutateStatusDevices(item.active).status }}</span>
        </template>
        <template v-slot:body>
            <viewbox v-if="showModal" @close="showModal = false" :obj="this.item" :editform="this.editform" />
        </template>
    </modal>
    
    <!-- <viewbox v-if="showModal" @close="showModal = false" :obj="this.item" :editform="this.editform" /> -->

</template>

<script>
import tablecustom from '@/components/globaltable/index';
import modal from '@/components/modal/modal-lg'
import viewbox from './view'
// import infoblocks from '@/components/info/blocks'
import { mutateStatusDevices } from '@/usabilityScripts/globalMutate'

export default {
    props: ['obj', 'number', 'devices', 'objTerminals', 'objTradepoints'],
    components: { 
        tablecustom, 
        viewbox, 
        modal,
        // infoblocks
    },
    data() {
        return {
            form: {},
            // oldRow: "",
            showModal: false,
            item: "", 
            editform: false,
            objParams: {
                search: ''
            },
            columns: [
                {
                    name: this.$t("ID"),
                    text: "deviceId",
                    align: "left",
                    status: true,
                },
                {
                    name: "Status",
                    text: "active",
                    align: "left",
                    status: true,
                    mutate: (item) => mutateStatusDevices(item).status,
                    mutateClass: (item) => mutateStatusDevices(item).color
                },
                {
                    name: "ТТ",
                    text: "tradepointId",
                    align: "left",
                    status: true,
                    mutate: (item, obj) => obj.namett + " / " + obj.nameTerminal
                },
                {
                    name: this.$t("Point_name"),
                    text: "deviceTitle",
                    align: "left",
                    status: true,
                },
                {
                    name: this.$t("type"),
                    text: "type",
                    align: "left",
                    status: true,
                },
                {
                    name: this.$t("manufacturer"),
                    text: "manufacturer",
                    align: "left",
                    status: true,
                },
                {
                    name: this.$t("bank_terminal_model"),
                    text: "model",
                    align: "left",
                    status: true,
                },
                {
                    name: this.$t("OS"),
                    text: "os",
                    align: "left",
                    status: true,
                },
                {
                    name: this.$t("Protocol"),
                    text: "protocol",
                    align: "left",
                    status: true,
                }
            ],
            filterAll: [
                {
                    page: "devices",
                    name: "outlet",
                    category: "0",
                    items: []
                },
                {
                    page: "devices",
                    name: "terminal",
                    category: "0",
                    items: []
                },
                {
                    page: "devices",
                    name: "type",
                    category: "0",
                    items: []
                }
            ],
            selectnamett: "0",
            selectTerminal: "0",
            selecttype: "0",
        }
    },
    created(){
        // this.form = this.obj;
        // this.outlets = this.tt;
        this.getdata()
    },
    methods: {
        getdata(){
            this.form = this.obj
        
            //фільтр точок
            for(var item in this.form){
                for(var value in this.objTradepoints){
                    if(this.form[item].tradepointId === this.objTradepoints[value].tradepointId){
                        // this.form[item].statustt = this.$t('active');
                        this.form[item].namett = this.objTradepoints[value].tradepointName;
                        this.form[item].nameTerminal = this.getTitleTerminal(this.form[item].terminalId)
                        break;
                    } else {
                        this.form[item].namett = 'remove';
                    }
                }
            }

            let newobj = this.form;
            let newArrStatus = Array.from(new Set(newobj.map(item => JSON.stringify(item.namett)))).map(item => JSON.parse(item));
            this.filterAll[0]['items'] = newArrStatus;
            let newArrTerminal = Array.from(new Set(newobj.map(item => JSON.stringify(item.nameTerminal)))).map(item => JSON.parse(item));
            this.filterAll[1]['items'] = newArrTerminal;
            let newArrType = Array.from(new Set(newobj.map(item => JSON.stringify(item.type)))).map(item => JSON.parse(item));
            this.filterAll[2]['items'] = newArrType;
        },
        searchB(e){
            this.objParams.search = e
        },
        open(e){
            this.item = e;
            this.showModal = true;
        },
        clearFilter(){
            this.selectnamett = "0";
            this.selecttype = "0";
            this.selectTerminal = "0";
        },
        change(name, e){
            if(name == 'outlet'){
                this.selectnamett = e;
            } else if (name == 'type'){
                this.selecttype = e;
            } else if (name == 'terminal'){
                this.selectTerminal = e
            }
        },
        getTitleTT(item) {
            var name = "";
            this.objTradepoints.forEach((el) => {
                if(el.tradepointId === item.tradepointId) {
                    name = el.tradepointName
                }
            })
            return name
        },
        getTitleTerminal(item){
            var name = "";
            this.objTerminals.forEach((el) => {
                if(el.terminalId === item) {
                    name = el.terminalName
                }
            })
            return name
        },
        mutateProtocol(e){
            return mutateProtocolDevices(e)
        },
        mutateStatusDevices(e){
            return mutateStatusDevices(e)
        }
    },
    computed: {
        filteredItems: function() {
            if(this.form != null || this.form != undefined) {
                return Object.values(this.form)
                // По полю поиска
                .filter(item => {
                    return this.objParams.search == '' || item.deviceId.toString().toLowerCase().indexOf(this.objParams.search.toLowerCase()) !== -1 || item.deviceTitle.toString().toLowerCase().indexOf(this.objParams.search.toLowerCase()) !== -1 || item.namett.toString().toLowerCase().indexOf(this.objParams.search.toLowerCase()) !== -1 ;
                })

                // По точке
                .filter(item => {
                    return this.selectnamett == 0 || item.namett == this.selectnamett;
                })

                // По касе
                .filter(item => {
                    return this.selectTerminal == 0 || item.nameTerminal == this.selectTerminal;
                })

                // По типу
                .filter(item => {
                    return this.selecttype == 0 || item.type == this.selecttype;
                })
            }
        },
    }

}
</script>